<template>
  <v-row style="z-index: 20003">
    <v-dialog
      v-model="showDialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      scrollable
      persistent
      no-click-animation
      :retain-focus="false"
      max-width="1150px"
      max-height="90%"
    >
      <v-card
        ><!-- v-if="!isLoading">-->
        <v-card-title
          style="padding: 5px 0 0 5px"
          :class="$vuetify.breakpoint.mobile ? 'fixNotchPaddingTop' : ''"
        >
          <v-col v-if="!$vuetify.breakpoint.mobile" cols="12">
            <span style="font-size: 20px">
              {{
                !isEditable
                  ? $t("wkt.client.expensesheets.edit-item-dialog.view_title")
                  : !data.id
                  ? $t("wkt.client.expensesheets.edit-item-dialog.new_title")
                  : $t("wkt.client.expensesheets.edit-item-dialog.edit_title")
              }}
            </span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="close()">close</v-icon>
						</v-btn>-->
          </v-col>
          <v-col
            v-if="$vuetify.breakpoint.mobile"
            cols="12"
            class="pa-2 d-flex align-center"
          >
            <!--<v-col v-if="$vuetify.breakpoint.mobile" cols="12" class="pa-2 d-flex justify-space-between align-center">-->
            <v-btn icon @click="close()">
              <v-icon color="#185EA9">arrow_back</v-icon>
            </v-btn>
            <span class="text-truncate black--text" style="font-size: 20px">
              {{
                !isEditable
                  ? $t("wkt.client.expensesheets.edit-item-dialog.view_title")
                  : !data.id
                  ? $t("wkt.client.expensesheets.edit-item-dialog.new_title")
                  : $t("wkt.client.expensesheets.edit-item-dialog.edit_title")
              }}
            </span>
            <!--<v-btn icon @click="openCamera()">
							<v-icon color="#185EA9">camera_alt</v-icon>
						</v-btn>-->
          </v-col>
        </v-card-title>
        <v-skeleton-loader v-if="isLoading" type="table-tbody" class="my-4" />
        <!--<v-divider></v-divider>-->
        <v-card-text v-if="!isLoading" @wheel="onWheel">
          <v-form ref="form">
            <v-row>
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-autocomplete
                  v-model="data.sheetId"
                  :items="sheets"
                  item-text="name"
                  item-value="id"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.expense_sheet'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.expense_sheet_placeholder'
                    )
                  "
                  menu-props="bottom, offsetY"
                  :rules="[validationRules.required]"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-autocomplete
                  v-model="data.categoryId"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.category')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.category_placeholder'
                    )
                  "
                  menu-props="bottom, offsetY"
                  :rules="[validationRules.required]"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-autocomplete
                  v-model="formatType"
                  :items="formatTypes"
                  item-text="name"
                  item-value="id"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.format_type')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.format_type_placeholder'
                    )
                  "
                  menu-props="bottom, offsetY"
                  :rules="[validationRules.required]"
                  return-object
                  @change="showInvoiceFields($event.id === 1)"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-autocomplete
                  v-model="paymentMethod"
                  :items="paymentMethods"
                  item-text="name"
                  item-value="id"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.payment_method'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.payment_method_placeholder'
                    )
                  "
                  menu-props="bottom, offsetY"
                  :rules="[validationRules.required]"
                  return-object
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-text-field
                  v-model="ticketDateFormatted"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.ticket_date')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.ticket_date_placeholder'
                    )
                  "
                  class="mt-2"
                  :rules="[validationRules.required]"
                  readonly
                  @click.stop="isEditable ? showDateTimeDialog() : null"
                  :disabled="!isEditable"
                />
              </v-col>
              <!--<v-col cols="6">
								<v-text-field
								v-model="time"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.time')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.time_placeholder')"
								:rules="[validationRules.required]"  
								class="mt-2"    
								readonly 
								@click.stop="showDateTimeDialog()"
							/>
							</v-col>-->
              <v-col
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-text-field
                  v-model="data.expenseDescription"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.expense_description'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.expense_description_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="[validationRules.required]"
                  max="255"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                v-if="onlyForInvoice"
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-text-field
                  v-model="data.vendorVatNumber"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.vendor_vat_number'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.vendor_vat_number_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required] : []"
                  max="18"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col
                v-if="onlyForInvoice"
                :cols="$vuetify.breakpoint.mobile ? '12' : '6'"
                style="padding-bottom: 0"
              >
                <v-text-field
                  v-model="data.vendorName"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.vendor_name')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.vendor_name_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required] : []"
                  max="255"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col v-if="onlyForInvoice" cols="6" style="padding-bottom: 0">
                <v-text-field
                  v-model="taxesPercent"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.taxes_percent'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.taxes_percent_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required, validationRules.decimalSeparator, validationRules.isValidRange] : []"
                  type="text"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col v-if="onlyForInvoice" cols="6" style="padding-bottom: 0">
                <v-text-field
                  v-model="taxesAmount"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.taxes_amount')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.taxes_amount_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required, validationRules.decimalSeparator] : []"
                  type="text"
                  min="0"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col v-if="onlyForInvoice" cols="6" style="padding-bottom: 0">
                <v-text-field
                  v-model="grossAmount"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.gross_amount')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.gross_amount_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required, validationRules.decimalSeparator] : []"
                  type="text"
                  min="0"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col cols="6" style="padding-bottom: 0">
                <v-text-field
                  v-model="totalAmount"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.total_amount')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.total_amount_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="[validationRules.required, validationRules.decimalSeparator]"
                  type="text"
                  min="0"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col v-if="onlyForInvoice" cols="12" style="padding-bottom: 0">
                <v-text-field
                  v-model="data.ticketNumber"
                  :label="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.ticket_number'
                    )
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.ticket_number_placeholder'
                    )
                  "
                  autocomplete="none"
                  :rules="onlyForInvoice ? [validationRules.required] : []"
                  max="50"
                  :disabled="!isEditable"
                />
              </v-col>
              <v-col v-if="onlyForInvoice" cols="12" style="padding-bottom: 0">
                <v-textarea
                  v-model="data.description"
                  :label="
                    $t('wkt.client.expensesheets.edit-item-dialog.description')
                  "
                  :placeholder="
                    $t(
                      'wkt.client.expensesheets.edit-item-dialog.description_placeholder'
                    )
                  "
                  autocomplete="none"
                  max="4000"
                  :disabled="!isEditable"
                />
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <!-- Archivo adjunto -->
            <v-col
              v-if="
                isEditable &&
                !file &&
                !data.documentPath &&
                $vuetify.breakpoint.mobile
              "
              cols="12"
              style="padding-bottom: 0"
            >
              <h3 style="margin: 12px 0; color: #000000">
                {{
                  $t("wkt.client.expensesheets.edit-item-dialog.attached_file")
                }}
              </h3>
              <v-btn
                color="#185EA9"
                :disabled="isUpdating"
                class="mt-1 white--text"
                @click="attachDocument()"
              >
                <v-icon class="mr-4">cloud_upload</v-icon>
                {{ $t("wkt.client.common.dialog-buttons.attach_file") }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept=".png,.jpg"
                @change="onFileChanged"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="!file && data.documentPath"
              cols="12"
              class="mt-4 pt-0"
            >
              <h3>
                {{
                  $t("wkt.client.expensesheets.edit-item-dialog.attached_file")
                }}
              </h3>
              <div class="my-2 d-flex align-center justify-center">
                <v-img
                  contain
                  :src="base64Image"
                  width="100"
                  height="150"
                  style="cursor: pointer"
                  @click.stop="documentClicked = true"
                ></v-img>
              </div>
              <div class="d-flex align-center justify-space-between">
                <span class="text-truncate">{{ data.documentName }}</span>
                <v-icon
                  v-if="isEditable"
                  color="#185EA9"
                  @click.stop="deleteExpenseSheetItemDocument()"
                  >delete</v-icon
                >
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--<v-divider></v-divider>-->
        <v-card-actions
          v-if="!isLoading"
          :class="$vuetify.breakpoint.mobile ? 'fixNotchPaddingBottom' : ''"
        >
          <!--<v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.client.common.dialog-buttons.delete') }}</span>
					</v-btn>-->
          <v-btn
            v-if="isEditable && data.id"
            color="#ff0000"
            text
            @click="confirmDelete()"
            >{{ $t("wkt.client.common.dialog-buttons.delete") }}</v-btn
          >
          <v-btn
            v-if="
              isEditable &&
              !file &&
              !data.documentPath &&
              !$vuetify.breakpoint.mobile
            "
            color="#185EA9"
            text
            :disabled="isUpdating"
            @click="attachDocument()"
            >{{ $t("wkt.client.common.dialog-buttons.attach_file") }}</v-btn
          >
          <input
            ref="uploader"
            class="d-none"
            type="file"
            accept=".png,.jpg"
            @change="onFileChanged"
          />
          <v-spacer></v-spacer>
          <v-btn v-if="isEditable" color="#185EA9" text @click="save()">{{
            $t("wkt.client.common.dialog-buttons.ok")
          }}</v-btn>
          <v-btn text @click="close()">{{
            isEditable
              ? $t("wkt.client.common.dialog-buttons.cancel")
              : $t("wkt.client.common.dialog-buttons.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay v-if="documentClicked">
        <v-img
          contain
          :src="base64Image ? base64Image : ''"
          :width="zoomedImageWidth"
          :height="zoomedImageHeight"
          @click="documentClicked = false"
        ></v-img>
      </v-overlay>
    </v-dialog>

    <ReadingTicketDialog ref="dlgReadingTicket" />
    <ConfirmTicketDialog ref="dlgConfirmTicket" />
    <SelectDateTimeDialog ref="dlgSelectDateTime" />

    <ConfirmDialog
      ref="dlgConfirm"
      v-bind:title="
        $t('wkt.client.expensesheets.edit-item-dialog.delete_title')
      "
      v-bind:message="
        $t('wkt.client.expensesheets.edit-item-dialog.delete_text')
      "
      v-bind:titleOk="$t('wkt.client.common.dialog-buttons.delete')"
      v-bind:titleCancel="$t('wkt.client.common.dialog-buttons.cancel')"
      v-on:confirmed="deleteItem(true)"
    />
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ReadingTicketDialog from "./ReadingTicketDialog";
import ConfirmTicketDialog from "./ConfirmTicketDialog";
import SelectDateTimeDialog from "../../common/SelectDateTimeDialog";
import ConfirmDialog from "../../common/ConfirmDialog";
import discovery from "../../../discovery";
import api from "../../../api/worktime";
import gwt from "../../../api/gwt";

export default {
  name: "ExpenseSheetItemDialog",
  mixins: [BaseModule],
  components: {
    ReadingTicketDialog,
    ConfirmTicketDialog,
    SelectDateTimeDialog,
    ConfirmDialog,
  },
  data() {
    return {
      showDialog: false,
      isLoading: false,
      isEditable: false,
      //sheetId: null,
      data: {},
      taxesPercent: null,
      taxesAmount: null,
      grossAmount: null,
      totalAmount: null,
      discovery: discovery,
      documentClicked: false,
      ticketDateFormatted: null,
      isUpdating: false,
      file: null,
      msgCbUpdated: null,
      msgCbDeleted: null,
      sheets: [],
      categories: [],
      formatType: null,
      formatTypes: [
        {
          id: 0,
          name: this.$t(
            "wkt.client.expensesheets.detail-window.items.format-type.ticket"
          ),
        },
        {
          id: 1,
          name: this.$t(
            "wkt.client.expensesheets.detail-window.items.format-type.invoice"
          ),
        },
      ],
      paymentMethod: null,
      paymentMethods: [
        {
          id: 0,
          name: this.$t(
            "wkt.client.expensesheets.detail-window.items.payment-method-type.cash"
          ),
        },
        {
          id: 1,
          name: this.$t(
            "wkt.client.expensesheets.detail-window.items.payment-method-type.company_card"
          ),
        },
        {
          id: 2,
          name: this.$t(
            "wkt.client.expensesheets.detail-window.items.payment-method-type.other"
          ),
        },
      ],
      base64Image: null,
      onlyForInvoice: false,
    };
  },
  computed: {
    zoomedImageWidth() {
      return window.innerWidth * 0.9;
    },
    zoomedImageHeight() {
      return window.innerHeight * 0.9;
    },
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    open(id, sheetId, isEditable, msgCbUpdated, msgCbDeleted) {
      this.isEditable = isEditable;

      //this.sheetId = sheetId;
      this.taxesPercent = null;
      this.taxesAmount = null;
      this.grossAmount = null;
      this.totalAmount = null;
      this.formatType = null;
      this.paymentMethod = null;
      this.ticketDateFormatted = null;
      this.msgCbUpdated = msgCbUpdated;
      this.msgCbDeleted = msgCbDeleted;
      this.file = null;
      this.isUpdating = false;
      this.onlyForInvoice = true;
      this.documentClicked = false;
      this.showDialog = true;

      this.showInvoiceFields(false);

      this.getExpenseSheets();
      this.getExpenseSheetCategories();

      if (!id) {
        this.data = {
          sheetId: sheetId,
        };

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        return;
      }

      this.getExpenseSheetItemById(id);
    },
    close() {
      if (this.data.id && !this.formatType) {
        this.deleteItem(false);
        return;
      }

      this.showDialog = false;
    },
    getExpenseSheets() {
      this.isLoading = true;

      const companyId = gwt.getSessionInformation().company.id;

      api.getExpenseSheets(
        companyId,
        null,
        false,
        (data) => {
          //this.isLoading = false;
          //Solo las hojas con estado "EN PREPARACIÓN" o "DENEGADAS" son editables
          this.sheets = data.filter((e) => [-1, 2].includes(e.status));
        },
        (err) => {
          this.isLoading = false;
          this.$log.error(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    getExpenseSheetCategories() {
      //this.isLoading = true;

      api.getExpenseSheetCategories(
        (data) => {
          this.isLoading = false;
          this.categories = data;
        },
        (err) => {
          this.isLoading = false;
          this.$log.error(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    getExpenseSheetItemById(id) {
      this.isLoading = true;

      api.getExpenseSheetItemById(
        id,
        (data) => {
          //this.isLoading = false;
          this.data = data;

          this.formatType = this.formatTypes.find(
            (f) => f.id === data.formatType
          );
          this.paymentMethod = this.paymentMethods.find(
            (p) => p.id === data.paymentMethod
          );

          this.showInvoiceFields(this.formatType.id === 1); /* 1 -> INVOICE */

          if (this.data.ticketDate) {
            this.ticketDateFormatted = this.formatLongDateTime(
              this.data.ticketDate,
              true
            );
          }

          if (data.taxesPercent) {
            this.taxesPercent = this.formatCurrency(data.taxesPercent);
          }

          if (data.taxesAmount) {
            this.taxesAmount = this.formatCurrency(data.taxesAmount);
          }
          if (data.grossAmount) {
            this.grossAmount = this.formatCurrency(data.grossAmount);
          }
          if (data.totalAmount) {
            this.totalAmount = this.formatCurrency(data.totalAmount);
          }

          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }

          if (this.data.documentPath) {
            this.downloadDocumentContent();
          }
        },
        (err) => {
          this.isLoading = false;
          this.$log.error(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    showInvoiceFields(show) {
      this.onlyForInvoice = show;
    },
    showDateTimeDialog() {
      this.$refs.dlgSelectDateTime.open(this.data.ticketDate, null, (date) => {
        this.data.ticketDate = date.getTime();
        this.ticketDateFormatted = this.formatLongDateTime(
          this.data.ticketDate,
          true
        );
      });
    },
    downloadDocumentContent() {
      //this.isLoading = true;

      this.downloadExpenseSheetItemDocumentContentAsBase64(
        this.data.sheetId,
        this.data.id,
        (data) => {
          //this.isLoading = false;
          this.base64Image = data;
        },
        (err) => {
          //this.isLoading = false;
          console.log(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    downloadDocument() {
      gwt.downloadFile(
        `user/expense-sheet-item/${this.data.sheetId}/download/${this.data.id}`,
        this.data.documentName
      );
    },
    openCamera() {
      alert("openCamera");
    },
    attachDocument() {
      //this.isUpdating = true;
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const file = e.target.files[0];

      // eslint-disable-next-line no-unused-vars
      const fileName = file.name.substr(0, file.name.lastIndexOf("."));
      const fileNameExt = file.name.substr(file.name.lastIndexOf("."));
      if (fileNameExt.toLowerCase() === ".heic") {
        this.heicToJpg(file, fileName, (newFile) => {
          this.continueUploadFile(newFile);
        });
        return;
      }

      this.continueUploadFile(file);
    },
    continueUploadFile(file) {
      this.$refs.dlgReadingTicket.open();

      let formData = new FormData();
      formData.append("sheetId", this.data.sheetId);
      if (this.data.id) {
        formData.append("sheetItemId", this.data.id);
      }
      formData.append("file", file, file.name);

      api.extractExpenseSheetItemTicketInfo(
        formData,
        (data) => {
          this.$refs.dlgReadingTicket.close();

          this.file = null;

          if (data) {
            this.data = data.item;

            if (data.info) {
              this.$refs.dlgConfirmTicket.open(data.info, () => {
                this.data.ticketNumber = data.info.ticketNumber;
                this.data.vendorVatNumber = data.info.vendorVatNumber;
                this.data.vendorName = data.info.vendorName;
                this.data.ticketDate = this.buildDateTime(
                  data.info.date,
                  data.info.time
                );
                this.ticketDateFormatted = this.formatLongDateTime(
                  this.data.ticketDate,
                  true
                );
                this.taxesPercent = data.info.taxesPercent
                  ? data.info.taxesPercent
                  : null;
                this.taxesAmount = data.info.taxesAmount
                  ? data.info.taxesAmount
                  : null;
                this.grossAmount = data.info.grossAmount
                  ? data.info.grossAmount
                  : null;
                this.totalAmount = data.info.totalAmount
                  ? data.info.totalAmount
                  : null;
              });
            }

            this.downloadDocumentContent();
          }

          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        },
        (err) => {
          this.$refs.dlgReadingTicket.close();
          console.log(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    deleteExpenseSheetItemDocument() {
      this.isLoading = true;

      api.deleteExpenseSheetItemDocument(
        this.data.id,
        (data) => {
          this.isLoading = false;
          this.data = data;
        },
        (err) => {
          this.isLoading = false;
          console.log(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.taxesAmount =this.formatCurrency(this.taxesAmount);
      this.grossAmount =this.formatCurrency(this.grossAmount);
      this.totalAmount =this.formatCurrency(this.totalAmount);
      this.taxesPercent =this.formatCurrency(this.taxesPercent);
      
      this.data.formatType = this.formatType.id;
      this.data.paymentMethod = this.paymentMethod.id;

      let formData = new FormData();

      // file
      if (this.file) {
        formData.append("file", this.file, this.file.name);
      }

      if (this.data.id) {
        formData.append("id", this.data.id);
      }
      formData.append("sheetId", this.data.sheetId);
      formData.append("categoryId", this.data.categoryId);
      if (this.onlyForInvoice) {
        formData.append("vendorName", this.data.vendorName);
        formData.append("vendorVatNumber", this.data.vendorVatNumber);
        formData.append("taxesPercent", Number(this.taxesPercent.replace(',', '.')));
        formData.append("taxesAmount", Number(this.taxesAmount.replace(',', '.')));
        formData.append("grossAmount", Number(this.grossAmount.replace(',', '.')));
        formData.append("ticketNumber", this.data.ticketNumber);
        if (this.data.description && this.data.description.trim().length > 0) {
          formData.append("description", this.data.description);
        }
      }
      formData.append("totalAmount", Number(this.totalAmount.replace(',', '.')));
      formData.append("formatType", this.data.formatType);
      formData.append("paymentMethod", this.data.paymentMethod);
      formData.append("ticketDate", this.data.ticketDate);
      formData.append("expenseDescription", this.data.expenseDescription);
      //formData.append("companyId", this.data.companyId);

      this.isLoading = true;

      api.storeExpenseSheetItem(
        formData,
        (data) => {
          this.isLoading = false;
          if (data) {
            this.$emit("show-alert", {
              text: this.$t(
                "wkt.client.expensesheets.edit-item-dialog.save_ok"
              ),
              color: "success",
              timeout: 3000,
            });
          } else {
            this.$emit("show-alert", {
              text: this.$t(
                "wkt.client.expensesheets.edit-item-dialog.save_error"
              ),
              color: "error",
              timeout: 3000,
            });
          }
          this.showDialog = false;
          if (this.msgCbUpdated) {
            this.msgCbUpdated();
          }
        },
        (err) => {
          this.isLoading = false;
          this.$log.error(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    buildDateTime(date, time) {
      if (!date || date.length == 0) {
        return null;
      }

      if (!time || time.length == 0) {
        time = "00:00";
      }

      const [day, month, year] = date.split("/");
      const [hours, minutes] = time.split(":");

      return new Date(year, month - 1, day, hours, minutes).getTime();
    },
    confirmDelete() {
      this.$refs.dlgConfirm.confirm(this.data);
    },
    deleteItem(notify) {
      this.isLoading = true;

      api.deleteExpenseSheetItemById(
        this.data.id,
        (res) => {
          this.isLoading = false;
          this.showDialog = false;
          if (notify) {
            if (res) {
              this.$emit("show-alert", {
                text: this.$t("wkt.client.expensesheets.edit-dialog.delete_ok"),
                color: "success",
                timeout: 3000,
              });
            } else {
              this.$emit("show-alert", {
                text: this.$t(
                  "wkt.client.expensesheets.edit-dialog.delete_error"
                ),
                color: "error",
                timeout: 3000,
              });
            }
            if (this.msgCbDeleted) {
              this.msgCbDeleted();
            }
          }
        },
        (err) => {
          this.isLoading = false;
          this.$log.error(err);
          this.$emit("show-alert", {
            text: err.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    validateInput(event) {
      if (this.decimalError) {
        event.preventDefault();
       event.stopPropagation();
      }
    },
  },
};
</script>
